/** 端末の画面の向き */
export enum ScreenOrientation {
  /** 値なし (初期値) */
  None,

  /** 縦長 */
  Portrait,

  /** 横長 */
  Landscape
}
